import { createAsyncThunk } from "@reduxjs/toolkit";

import { getHistory } from "libs/api/history";

// Building Thunk
export const getHistoryThunk = createAsyncThunk(
  "history/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getHistory(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
